module.exports = {
    config: {
        '/api': {
            // 公网生产
            target: 'https://renzhi.cqyynjjk.com/api/',
            socket: 'wss://renzhi.cqyynjjk.com/api/ws/',

            download: 'https://renzhi.cqyynjjk.com/',
            changeOrigin: true,  // 跨域
            pathRewrite: {
                '^/api': ''
            }
        }
    }
};




//////////////////
// WEBPACK FOOTER
// ./config/proxy.js
// module id = nmtd
// module chunks = 1